export const filterData = (data) => Object.fromEntries(Object.entries(data).filter(([_, value]) => {
  return value !== '';
}));